// utils/map.js
import L from 'leaflet';

export const busSvgIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#FF0000" viewBox="0 0 24 24">
  <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 2.99.71-.71z"/>
</svg>
`;

export const tramSvgIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#0000FF" viewBox="0 0 24 24">
  <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 2.99.71-.71z"/>
</svg>
`;

export function createVehicleSvgIcon(isBus) {
  return L.divIcon({
    html: isBus ? busSvgIcon : tramSvgIcon,
    className: 'vehicle-svg-icon',
    iconSize: [24, 24],
    iconAnchor: [12, 12],
    popupAnchor: [0, -12]
  });
}



export function createVehicleIcon(lineNumber, isTram, direction = 0) {
  const color = isTram ? '#0891B2' : '#DC2626';
  const str = String(lineNumber);
  const fontSize = str.length >= 4 ? 9 : str.length === 3 ? 11 : 13;

  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
         overflow="visible" style="filter: drop-shadow(0 2px 3px rgba(0,0,0,0.35));">
      <g transform="rotate(${direction}, 20, 20)">
        <polygon points="20,2 14,12 26,12" fill="${color}"/>
        <rect x="2" y="10" width="36" height="22" rx="6" fill="${color}"/>
        <rect x="2" y="10" width="36" height="22" rx="6" fill="none" stroke="white" stroke-width="2"/>
        <text x="20" y="22" text-anchor="middle" dominant-baseline="middle" fill="white"
              font-family="system-ui,-apple-system,sans-serif" font-weight="800" font-size="${fontSize}">${str}</text>
      </g>
    </svg>
  `;

  return L.divIcon({
    className: 'custom-vehicle-icon-wrapper',
    html: svg,
    iconSize: [40, 40],
    iconAnchor: [20, 20],
    popupAnchor: [0, -20],
  });
}

// Funkcja obliczająca centrum i zoom
export function calculateMapView (stops) {
  // Filtruj przystanki bez współrzędnych
  const stopsWithCoords = stops.filter(stop => stop.stopLat && stop.stopLon);
  
  if (stopsWithCoords.length === 0) return;
  
  // Znajdź min i max współrzędne
  const minLat = Math.min(...stopsWithCoords.map(stop => stop.stopLat));
  const maxLat = Math.max(...stopsWithCoords.map(stop => stop.stopLat));
  const minLon = Math.min(...stopsWithCoords.map(stop => stop.stopLon));
  const maxLon = Math.max(...stopsWithCoords.map(stop => stop.stopLon));
  
  // Oblicz centrum
  const centerLat = (minLat + maxLat) / 2;
  const centerLon = (minLon + maxLon) / 2;
  
  // Oblicz zoom na podstawie rozmiaru obszaru
  const latDiff = maxLat - minLat;
  const lonDiff = maxLon - minLon;
  const maxDiff = Math.max(latDiff, lonDiff);
  
  let zoom = 16; // Domyślne przybliżenie dla małego obszaru
  if (maxDiff > 0.1) {
    zoom = 12; // Oddalone dla dużego obszaru
  } else if (maxDiff > 0.05) {
    zoom = 14; // Średnie przybliżenie
  }
  
  return { center: [centerLat, centerLon], zoom}
};